<template>
  <div class="card" :class="widgetClasses">
    <div class="card-header align-items-center border-0 pt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label fw-bold text-dark">Produtos</span>
        <span class="text-muted mt-1 fw-semobold fs-7"
          >Produtos mais faturados</span
        >
      </h3>
      <div class="card-toolbar">
        <button
          type="button"
          class="btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
          data-toggle="tooltip"
          data-placement="top"
          title="Atualizar"
          @click="this.carregarTotalizadores()"
        >
          <span class="svg-icon svg-icon-2">
            <inline-svg src="media/icons/duotune/arrows/arr029.svg" />
          </span>
        </button>
      </div>
    </div>
    <div v-if="!loading" class="card-body pt-5">
      <template v-for="(item, index) in items" :key="index">
        <div
          :class="{ 'mb-7': items.length - 1 !== index }"
          class="d-flex align-items-center"
        >
          <div
            v-if="item && item.imagem ? item.imagem : ''"
            class="symbol symbol-50px me-5"
          >
            <div
              class="symbol-label fs-2 fw-bold bg-light-dark"
              :style="{
                'background-image': `url(${
                  this.$utils.getUrl() + item.imagem
                })`,
              }"
            ></div>
          </div>
          <div v-else class="symbol symbol-50px me-5">
            <div
              :class="[
                'symbol-label fs-2 fw-bold ' + this.$utils.getColorRandom(),
              ]"
            >
              {{ item.nome ? item.nome.substring(0, 1).toUpperCase() : "" }}
            </div>
          </div>
          <div class="flex-grow-1 me-5">
            <a href="#" class="text-dark fw-bold text-hover-primary fs-6">{{
              item.nome
            }}</a>

            <span class="text-muted d-block fw-semobold">{{
              item.descricao
            }}</span>
          </div>
          <div class="d-flex align-items-center">
            <div class="fw-bold fs-5 text-gray-800 pe-1">
              {{ item.qtd }}
            </div>
            <span class="svg-icon svg-icon-5 svg-icon-success ms-1">
              <inline-svg src="media/icons/duotune/arrows/arr066.svg" />
            </span>
          </div>
        </div>
      </template>
    </div>
    <div v-if="loading" class="card-body pt-5">
      <div v-bind:data-kt-indicator="loading ? 'on' : 'off'">
        <span class="indicator-progress">
          Aguarde, carregando...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"
          ></span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    widgetClasses: {
      type: String,
      required: false,
      default: "card-xl-stretch mb-xl-8",
    },
  },
  methods: {
    async carregarTotalizadores() {
      this.loading = true;
      this.items = [];
      try {
        let retFaturamento = await this.$store.dispatch(
          "faturamentoItem/getFaturamentoItemOData",
          "?$apply=filter(cancelado eq '0')/compute(nome as nome,Produto/descricao as descricao, Produto/imagem as imagem)/groupby((nome,descricao,imagem), aggregate(qtd with sum as qtd))&$orderby=qtd desc&$select=nome,descricao,imagem,qtd&$top=7"
        );

        if (retFaturamento && retFaturamento !== null) {
          this.items.push(...retFaturamento);
        }
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
    },
  },
  async mounted() {
    await this.carregarTotalizadores();
  },
  data() {
    return {
      loading: false,
      items: [],
    };
  },
};
</script>

<style lang="scss" scoped></style>
